import React from 'react';
import WidgetPreviewTitle from '../../WidgetPreviewTitle';
import {
  WIDGET_BANNER_SECTION_LAYOUT_INFO,
  WIDGET_SECTION_COMPONENT_TYPE,
} from '../../../../../../constants/service/app/widgetConstants';
import WidgetPreviewBannerSwipeLayout from '../WidgetPreviewBannerSwipeLayout';
import WidgetPreviewBannerGridLayout from '../WidgetPreviewBannerGridLayout';
import WidgetPreviewBannerScrollLayout from '../WidgetPreviewBannerScrollLayout';
import './WidgetPreviewBannerWrap.scss';

const WidgetPreviewBannerWrap = (props) => {
  const { widgetInfo, exposureWidgetItemList } = props;
  const { layoutType, mainTitle, isUsedSubTitle, subTitle } = widgetInfo;

  return (
    <div className="widget-preview-banner-wrap">
      {
        /**
         *  위젯 타이틀, 위젯 서브 타이틀
         */
        <WidgetPreviewTitle mainTitle={mainTitle} isUsedSubTitle={isUsedSubTitle} subTitle={subTitle} />
      }

      <div className="widget-banner-item-list">
        {WIDGET_BANNER_SECTION_LAYOUT_INFO[layoutType].COMPONENT_TYPE === WIDGET_SECTION_COMPONENT_TYPE.SWIPE ? (
          <WidgetPreviewBannerSwipeLayout list={exposureWidgetItemList} layoutType={layoutType} />
        ) : null}

        {WIDGET_BANNER_SECTION_LAYOUT_INFO[layoutType].COMPONENT_TYPE === WIDGET_SECTION_COMPONENT_TYPE.GRID ? (
          <WidgetPreviewBannerGridLayout list={exposureWidgetItemList} layoutType={layoutType} />
        ) : null}

        {WIDGET_BANNER_SECTION_LAYOUT_INFO[layoutType].COMPONENT_TYPE === WIDGET_SECTION_COMPONENT_TYPE.SCROLL ? (
          <WidgetPreviewBannerScrollLayout list={exposureWidgetItemList} layoutType={layoutType} />
        ) : null}
      </div>
    </div>
  );
};

export default WidgetPreviewBannerWrap;
